"use strict";
import { useScreenSize } from "hooks/screenSize/useScreenSize";
export function useIsMobile() {
  const isScreenSize = useScreenSize();
  const isMobile = !isScreenSize["sm"];
  return isMobile;
}
